const translations = {
    battery: 'Battery',
    flowMeter: 'Flow meter',
    motor: 'Motor',
    propellerSet: 'Propeller set',
    pump: 'Pump'
};

export default translations;
